// openEHR AM model — BMM package org.openehr.am.aom2.rules
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../base/mod.ts";
import * as openehr_lang from "../../lang/mod.ts";

/**
 * Expression tree leaf item representing a constraint on a primitive type, expressed in the form of a concrete subtype of C_PRIMITIVE_OBJECT.
 *
 * Official AM 2.4 (which includes LANG) extends `openehr_lang.EXPR_LEAF`.
 */
export class EXPR_CONSTRAINT extends openehr_lang.EXPR_LEAF {
  /**
   * The constraint.
   */
  override item?: openehr_base.Any = undefined;
}

/**
 * Expression tree leaf item representing a constraint on an archetype identifier.
 */
export class EXPR_ARCHETYPE_ID_CONSTRAINT extends EXPR_CONSTRAINT {
  /**
   * A C_STRING representing a regular expression for matching Archetype identifiers.
   */
  override item?: openehr_base.Any = undefined;
}

/**
 * Expression tree leaf item representing a reference to a value found in data at a location specified by a path in the archetype definition.
 *
 * * A path referring to a value in the archetype (paths with a leading ‘/’ are in the definition section.
 * * Paths with no leading ‘/’ are in the outer part of the archetype, e.g. “archetype_id/value” refers to the String value of the archetype_id attribute of the enclosing archetype.
 */
export class EXPR_ARCHETYPE_REF extends openehr_lang.EXPR_VALUE_REF {
  /**
   * Internal storage for path
   * @protected
   */
  protected _path?: openehr_base.String;

  /**
   * The path to the archetype node.
   */
  get path(): string | undefined {
    return this._path?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for path.
   * Use this to access openehr_base.String methods.
   */
  get $path(): openehr_base.String | undefined {
    return this._path;
  }

  /**
   * Sets path from either a primitive value or openehr_base.String wrapper.
   */
  set path(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._path = undefined;
    } else if (typeof val === "string") {
      this._path = openehr_base.String.from(val);
    } else {
      this._path = val;
    }
  }

  declare item?: openehr_base.Any;
}
